var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-overlay",
    {
      attrs: { show: !_vm.isValid, opacity: "0.5" },
      scopedSlots: _vm._u([
        {
          key: "overlay",
          fn: function () {
            return [
              _c("span", { staticClass: "material-icons error-icon" }, [
                _vm._v("error_outline"),
              ]),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("p", [
        _c("strong", [_vm._v("Size: ")]),
        _vm._v(
          " " +
            _vm._s(_vm.externalSize.length) +
            " x " +
            _vm._s(_vm.externalSize.width) +
            "mm external \n with " +
            _vm._s(_vm.apertureSize.length) +
            " x " +
            _vm._s(_vm.apertureSize.width) +
            "mm aperture"
        ),
        _c("br"),
        _vm.borderSizes
          ? _c("span", [
              _c("strong", [_vm._v("Borders: ")]),
              _vm._v(
                "Top: " +
                  _vm._s(_vm.borderSizes.top) +
                  "mm, Left: " +
                  _vm._s(_vm.borderSizes.left) +
                  "mm, Right: " +
                  _vm._s(_vm.borderSizes.right) +
                  "mm, Bottom: " +
                  _vm._s(_vm.borderSizes.bottom) +
                  "mm"
              ),
              _c("br"),
            ])
          : _vm._e(),
        _c("strong", [_vm._v("Colour:")]),
        _vm._v(
          " " +
            _vm._s(
              _vm.board
                ? `${_vm.board.name} at £${_vm.mountPrice} each`
                : `Please select a colour`
            )
        ),
        _c("br"),
        _c("strong", [_vm._v("Undermount:")]),
        _vm._v(
          " " +
            _vm._s(
              _vm.includeUndermount
                ? `Included at £${_vm.calcUndermountPrice} each`
                : `Not included`
            )
        ),
        _c("br"),
        _c("strong", [_vm._v("Quantity:")]),
        _vm._v(" " + _vm._s(_vm.quantity) + " at £" + _vm._s(_vm.itemPrice)),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }